var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"legend"},_vm._l((_vm.items),function(item,index){return _c('div',{key:index,staticClass:"item"},[_c('div',{staticClass:"mark",style:({
        'background-color': item.color,
      })}),_c('span',{staticClass:"small-text"},[_vm._v(_vm._s(item.name))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }